import api from './api';

const serviceProviderService = {
    getAll: async () => {
        const response = await api.get('/service-providers');
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/service-providers/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/service-providers', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/service-providers/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/service-providers/${id}`);
        return response.data;
    }
};

export default serviceProviderService;
